import React from "react";
import {SectionTitle} from "../../components/SectionTitle";
import {CtaButtonLink, HorizontalSlidingCard, HorizontalSlidingTextCard, StyledHorizontalSlidingCardsSection} from "./styles";
import {Carousel} from "../../components/Carousel";
import styles from "./styles.module.scss"
import theme from "@itchannelplus/styles/theme";
import {parseInt} from "lodash";
import { SimpleLinkProps, HORIZONTAL_SLIDE } from "@itchannelplus/utils";

import { CardProps, ICard, TextCardProps } from "../../components/Card/types";

/*
 {
      image: '/img/cards/1.png',
      caption: t('home.invitation_section.cards.title1'),
      title: t('home.invitation_section.cards.description1'),
      overlay: {
          caption: 'Dès 11 950 € par personne',
          text: 'Cet itinéraire vous emmène découvrir Cap Town, l’une des villes les plus aimées du monde!',
          ctaLabel: 'Découvrir',
          ctaUrl: 'https://www.google.com',
          ctaTarget: '_blank'
      }
    }
 */


export interface HorizontalSlidingCardsSectionProps {
  title?:string,
  tagline?: string,
  cards: ICard[],
  cta?: SimpleLinkProps,
  id?: string,
  children?: React.ReactNode;
}


export const HorizontalSlidingCardsSection =  ({title, tagline, cards, cta, id, children}: HorizontalSlidingCardsSectionProps) => {
  if (!cards || cards.length < 1)
    return <></>;
  return (
    <StyledHorizontalSlidingCardsSection id={id}>
      {title && <SectionTitle tagline={tagline}>{title}</SectionTitle>}
      <Carousel CTRLButtonsPosition={"around"} btnTheme={"dark"} slidesPerView={1.5} spaceBetween={15} breakpoints={{
        [parseInt(theme.breakpoints.tablet_landscape)]: {
          slidesPerView: 2.5,
          spaceBetween: 30
        },
        // when window width is >= 480px
        [parseInt(theme.breakpoints.desktop)]: {
          slidesPerView: 3.5,
          spaceBetween: 30
        }
      }} freeMode allowTouchMove className={styles.carouselContainer} showCTRLButtons autoHide  >
        { cards.map( ( card, i) =>  <React.Fragment key={"frag"+i}>
          { card.variant == 'text' && <HorizontalSlidingTextCard  {...card as TextCardProps} sizes={HORIZONTAL_SLIDE} key={"card"+i}/> }
          { card.variant != 'text' && <HorizontalSlidingCard  {...card} sizes={HORIZONTAL_SLIDE} key={"card"+i}/> }
        </React.Fragment>
          )
        }
      </Carousel>
      {cta && <CtaButtonLink href={cta.href}  label={cta.label} target={cta.target} size={"normal"}/>}
      {children}
    </StyledHorizontalSlidingCardsSection>
  );
};

export default  HorizontalSlidingCardsSection;
